import {Component, OnInit, ViewChild} from '@angular/core';

import {SelectedBookListComponent} from "./first-step/selected-book-list/selected-book-list.component";
import {SelectedUserListComponent} from "./first-step/selected-user-list/selected-user-list.component";
import {environment} from "../../../../src/environments/environment";
import {MailDetailsComponent} from "./second-step/mail-details.component";
import {BookSendService} from "./book-send.service";
import {AlertService} from 'app/shared/alert.service';

@Component({
  selector: 'app-book-send',
  templateUrl: './book-send.component.html',
  styleUrls: ['./book-send.component.scss']
})
export class BookSendComponent implements OnInit {

  @ViewChild(SelectedBookListComponent) finalBooksList: SelectedBookListComponent;
  @ViewChild(SelectedUserListComponent) finalUsersList: SelectedUserListComponent;
  @ViewChild(MailDetailsComponent) details: MailDetailsComponent;

  secondStep = false;
  sending = false;
  selectedBooks = [];
  selectedUsers = [];
  showMessage = false;
  genericImage = 'http://www.libreriaamericalatina.com/assets/images/shared/no-book.jpg';

  msg = {
    'sendMailSuccess': 'El correo ha sido enviado con éxito.',
    'sendMailError': 'Ocurrió un error al enviar el correo.',
  };

  constructor(
    private bookSendService: BookSendService,
    private alertService: AlertService){
  };

  ngOnInit() {
  }

  onContinueForm() {
    if (this.finalBooksList.selectedBooks.length > 0 && this.finalUsersList.selectedUsers.length > 0){
      this.selectedBooks = this.finalBooksList.selectedBooks.slice();
      this.selectedUsers = this.finalUsersList.selectedUsers.slice();
      this.secondStep = true;
    } else {
      if (this.finalBooksList.selectedBooks.length === 0) {
        this.finalBooksList.onValidationError = true;
      }
      if (this.finalUsersList.selectedUsers.length === 0) {
        this.finalUsersList.onValidationError = true;
      }
    }
  }

  createHTML(): string {
    return this.selectedBooks.map((book, i) => {
      const padding_top = (i * 22) + 70;
      const urlReference = environment.rootUrl+ book.isbn + ';lR=true';
      const htmlBook = '<div style = "padding-top:'+ padding_top +'px;padding-left:30px;padding-bottom:30px;width:100%;float:left">' +
        '<div style = "width: 25%;float:left;">' +
        '<img src= " ' + this.imgUrl(book) + ' "style="width: 100%"></div>' +
        '<div style = "float:left;width: 50%;padding-left:100px;">' +
        '<p> '+ book.title + '</p>' +
        '<p>' + book.author + '</p>' +
        '<p>' + book.editorial + '</p>' +
        '<p>' + book.isbn + '</p>' +
        // '<p>' + book.review.split(" ").slice(0, 50).join(" ") + '...' +  '</p>' +
        '<p>' + 'Precio: $' + book.price +  '</p>' +
        '<a href="'+ urlReference +'">Ver más</a>' +
        '</div>' +
        '</div>';
      return htmlBook;
    })
    .join('');
  }

  imgUrl(book) {
    if (book.imgCoverUrl) {
      // if this.book.imgCoverUrl exists then will be in folowing formats isbn.jpg or http link,
      // so will have more than 4 characters
      let cover = book.imgCoverUrl;
      cover = cover.slice(0, cover.length - 4);
      if (cover && !isNaN(+cover)) {
        return `${environment.coversUrl}${book.imgCoverUrl}`;
      } else {
        return `${book.imgCoverUrl}.jpg`;
      }
    } else {
      return this.genericImage;
    }
  }

  sendMail() {
    if (this.secondStep) {
      this.sending = true;
      this.showMessage = true;
      const html = this.createHTML();
      this.bookSendService.sendMail(this.details.detailsForm.get('subject').value, this.details.detailsForm.get('textMail').value, html, this.selectedUsers).subscribe(
        sendResponse => {
          this.initialization();
          this.alertService.success(this.msg['sendMailSuccess']);
        },
        error => {
          this.initialization();
          this.alertService.error(this.msg['sendMailError']);
        }
      );
    }
  }

  initialization() {
    this.secondStep = false;
    this.sending = false;
    this.selectedBooks = [];
    this.selectedUsers = [];
    setTimeout(() => {this.showMessage = false},8000);
  }

}



// WEBPACK FOOTER //
// ./src/app/book/book-send/book-send.component.ts